import Notification from 'stimulus-notification'

export default class extends Notification {

  static values = {
    ...Notification.values,
    autohide: Boolean
  }

  connect() {
    super.connect()
    this.alertElement().style.setProperty('--fd-transition-alert', `${this.delayValue}ms`)
  }

  alertElement() {
    return this.element // looking for element '.alert'
  }

  show () {
    this.enter()

    if (this.autohideValue) {
      this.timeout = setTimeout(this.hide, this.delayValue)
    }
  }
}
